import { DocumentsAction, DocumentsActionTypes } from './documents.actions';
import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';
import { Document } from './documents.models';

export const DOCUMENTS_FEATURE_KEY = 'bsDsocuments';

/**
 * Interface for the 'Documents' data used in
 *  - DocumentsState, and
 *  - documentsReducer
 *
 *  Note: replace if already defined in another module
 */

export const documentEntityAdapter: EntityAdapter<
  Document
> = createEntityAdapter<Document>({
  selectId: (document: Document) => document.id,
  sortComparer: false
});

export interface DocumentsState extends EntityState<Document> {
  selectedId?: number; // which Documents record has been selected
  loaded: boolean; // has the Documents list been loaded
  loading: boolean; // has the Documents list been loading
  error?: any; // last none error (if any)
}

export interface DocumentsPartialState {
  readonly [DOCUMENTS_FEATURE_KEY]: DocumentsState;
}

export const initialState: DocumentsState = documentEntityAdapter.getInitialState(
  {
    loaded: false,
    loading: false
  }
);

export function documentsReducer(
  state: DocumentsState = initialState,
  action: DocumentsAction
): DocumentsState {
  switch (action.type) {
    case DocumentsActionTypes.LOAD_OWNER_DOCUMENTS:
    case DocumentsActionTypes.SAVE_DOCUMENT_INFORMATION:
    case DocumentsActionTypes.UPDATE_DOCUMENT_INFORMATION:
      return {
        ...state,
        loaded: false,
        error: undefined
      };

    case DocumentsActionTypes.SAVE_UPLOAD_SUCCESS:
      return {
        ...documentEntityAdapter.upsertOne(action.payload, state),
        loaded: true
      };

    case DocumentsActionTypes.UPDATE_UPLOAD_SUCCESS:
      return {
        ...documentEntityAdapter.updateOne(
          { id: action.payload.id, changes: action.payload },
          state
        ),
        loaded: true
      };

    case DocumentsActionTypes.LOAD_OWNER_DOCUMENTS_SUCCESS:
      return {
        ...documentEntityAdapter.addMany(action.payload, state),
        loaded: true
      };

    case DocumentsActionTypes.SAVE_UPLOAD_FAIL:
    case DocumentsActionTypes.UPDATE_UPLOAD_FAIL:
      return {
        ...state,
        loaded: true,
        error: action.payload
      };

    default:
      return state;
  }
}
